module.exports = __webpack_public_path__ + "static/backlinks-99bacc407f67f2e0106173664fa6837d.png";